import Recat from 'react'
import {Component} from 'react'
import {Container, Form, Button, Card} from 'react-bootstrap'
import './main.css';
import Copyright from './Copyright'
import twitterIm from './twitterIm.webp'
import notesi from './notesi.png'
import sparklei from './sparklei.png'
import { ImMagicWand } from "react-icons/im";
import { BsChevronDown } from "react-icons/bs";
import Spinner from 'react-bootstrap/Spinner';



import './productpage.css'
import btnimg from './magicsi.png'


const {Configuration, OpenAIApi}=require("openai");


class SocialPostWriter extends Component{
  constructor() {
    super()
    this.state =  {
      loading: false,
      heading: 'Your response will be shown here..',
      response: ''
    }

  };

onFormSubmit = e => {

  e.preventDefault()
  const formData = new FormData(e.target),
  formDataObj= Object.fromEntries(formData.entries())
  this.setState({loading:true})

  // console.log(formDataObj.topicName)
  // console.log(formDataObj.selected)
  // console.log(formDataObj.selectedu)
  // OpenAI API ===================================================

  const configuration = new Configuration({
    apiKey: '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',
  });
  const openai = new OpenAIApi(configuration);

    openai.createCompletion({
    model: "text-davinci-003",
    prompt: `Write a ${formDataObj.selectedu} on topic - ${formDataObj.topicName} in ${formDataObj.selected} tone`,
    temperature: 1,
    max_tokens: 1001,
    top_p: 1,
    frequency_penalty: 0,
    presence_penalty: 0,
  })
  .then((response) => {
    this.setState({
      heading: `Here's your ${formDataObj.selectedu} on ${formDataObj.topicName}`,
      response: `${response.data.choices[0].text}`,
      loading: false
    }
  )
  }

);


}

// API ends===============================================
 render(){
  return (
<div className="main">
  <h1 style={{textAlign:"center", color: "white", paddingTop: "8rem", paddingBottom: "1rem"}}> <img src={sparklei} width="40px"/> Writing <span style={{backgroundImage: "linear-gradient(60deg, #00eeff, #ff00d9)", webkitBackgroundClip: "text",
 webkitTextFillColor: "transparent", fontWeight:"bold"}} >Social Posts</span> Just Got Easier!</h1>
  <p className="text-center" style={{color: "#FAF9F6"}}> Use AI to generate tons of engaging content.</p>
  <div className="flexwala" style={{display:"flex"}}>
  <div className="first">
    <Container/>
    <br/>
    <br/>
    <Form onSubmit={this.onFormSubmit}>

    <Form.Group className="mb-3">
      <Form.Label style={{color: "white"}}>Select Use case <BsChevronDown/></Form.Label>
      <Form.Control as="select" name="selectedu">
        <option value="Twitter Post">Twitter Post</option>
        <option value="LinkedIn Post">LinkedIn Post</option>
        <option value="Instagram Caption">Instagram Caption</option>
        <option value="Facebook Post">Facebook Post</option>
      </Form.Control>
    </Form.Group>
    <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label style={{color: "white"}}>What topic you want to write on?</Form.Label>
        <Form.Control type="text" placeholder="Enter topic" name="topicName" style={{width:"100%"}} />
        <Form.Text className="text-muted">
          Detailed information will result in great suggestions
        </Form.Text>
    </Form.Group>
    <Form.Group className="mb-3">
        <Form.Label style={{color: "white"}}>Select tone <BsChevronDown/></Form.Label>

        <Form.Control as="select" name="selected" >
          <option value="Appreciative">Appreciative</option>
          <option value="Assertive">Assertive</option>
          <option value="Convincing">Convincing</option>
          <option value="Critical">Critical</option>
          <option value="Enthusiastic">Enthusiastic</option>
          <option value="Formal">Formal</option>
          <option value ="Funny">Funny</option>
          <option value="Informative">Informative</option>
          <option value="Inspirational">Inspirational</option>
          <option value="Thoughtful">Thoughtful</option>
          <option value="Worried">Worried</option>
        </Form.Control>
      </Form.Group>
<div style={{ display: "flex"}}>
      <Button variant="info" type="submit">
              Get AI Suggestions <img src={btnimg} width="30px" />
      </Button>
      <div style={{paddingTop:"5px", paddingLeft: "4px"}}>

      {this.state.loading? <Spinner animation="border" variant="info" />: <></> }
      </div>
      </div>
      </Form>
            <br/>
            <br/>
            <Card/>
            <Card.Body/>
            <Card.Title/><h4 style={{color: "snow"}}><img src={notesi} width="30px"/> {this.state.heading}</h4>
            <Card.Title/>
            <br/>
            <br/>
            <Card.Text/><p style={{color: "#F5F5F5"}}>{this.state.response}</p>
            <Card.Text/>
            <Card.Body/>
            <Card/>
            <Container/>
            </div>
            <div className="second">
            <img src={twitterIm} style={{width: "100%", borderRadius:"6px"}} />
            </div>
            </div>
</div>
)
 }
}
export default SocialPostWriter
